import styled from "styled-components";

const View = styled.div`
  position: absolute;
  left: 0;
  top: 1755px;
  width: 100%; 
  padding-left: 30px;

  p {
    font-size: 14px;
    line-height: 30px;
    color: #033085;
  }
`;

export {
  View
}
